module.exports = __webpack_public_path__ + "img/banner03.16e95b92.jpg";